/**
 * An UNFINISHED /register — step 1 saved, times never sent — and how the
 * admin surfaces name it. Mirrors functions/registerStep1.js (the server
 * side of the same fact); keep the predicate identical.
 *
 * Why this exists (2026-09-07): step 1 of /register writes a lead so an
 * abandoned family is not lost, tagged stage:'register-step1'. Inquiries
 * rendered it as a plain inquiry and the Registration tab (which reads
 * registrationRequests, written at step 3) never saw it — so Anthony read
 * three such families as "filled out the wrong form". They had not.
 */
export const REGISTER_STEP1_STAGE = 'register-step1';

export const toMillis = (v) => {
	if (v == null) return null;
	if (typeof v.toMillis === 'function') return v.toMillis();
	if (typeof v.toDate === 'function') return v.toDate().getTime();
	if (v instanceof Date) return v.getTime();
	if (typeof v === 'number') return v;
	if (typeof v.seconds === 'number') return v.seconds * 1000;
	return null;
};

export const isUnfinishedStep1 = (lead) =>
	Boolean(lead) &&
	lead.stage === REGISTER_STEP1_STAGE &&
	!lead.registrationRequestId &&
	!lead.familyId &&
	lead.status === 'new';

export const daysSince = (v, nowMs = Date.now()) => {
	const m = toMillis(v);
	return m == null ? null : Math.max(0, Math.floor((nowMs - m) / 86400000));
};

const fmtShort = (v) => {
	const m = toMillis(v);
	return m == null ? '' : new Date(m).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
};

/** "Started registering · stopped before picking times · 3 days ago · nudged Sep 8" */
export const step1Line = (lead, nowMs = Date.now()) => {
	const d = daysSince(lead.createdAt, nowMs);
	const age = d == null ? '' : d === 0 ? 'today' : d === 1 ? '1 day ago' : `${d} days ago`;
	const parts = ['Started registering', 'stopped before picking times'];
	if (age) parts.push(age);
	if (lead.resumedAt) parts.push(`came back ${fmtShort(lead.resumedAt)}`);
	parts.push(lead.resumeNudgeSentAt ? `nudged ${fmtShort(lead.resumeNudgeSentAt)}` : 'not nudged yet');
	return parts.join(' · ');
};
